import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('ActivityLog', {params});
    }, 
    export(params) {
        return Service().get('ActivityLog/export/', {params});
    },    
}